export default __webpack_public_path__ + "static/media/team-hover.b160ad31.svg";